import Logo from "./Logo";
import NavButton from "./NavButton";
import NavigatorButtons from "./NavigatorButtons";
import classNames from "classnames";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import { setActiveProject, setActiveSection } from "../../store";

function TopNav({
  className,
  aboutRef,
  worksRef,
  experienceRef,
  contactRef,
  mainDivRef,
  preventIntersectionObserver,
}) {
  const dispatch = useDispatch();
  const { activeProject, activeSection } = useSelector((store) => store.app);

  function scrollToTargetAdjusted(ref) {
    const headerOffset = 65;
    const elementPosition = ref.current.getBoundingClientRect().top;
    const offsetPosition = elementPosition + mainDivRef.current.scrollTop - headerOffset;

    mainDivRef.current.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  }

  return (
    <div
      className={classNames(
        "h-[60px] w-full pl-nav-background flex flex-row items-center z-50",
        className
      )}
    >
      <Logo />
      <div className="grow" />
      <NavigatorButtons>
        <NavButton
          text="About"
          selected={activeSection === "about"}
          onClick={() => {
            dispatch(setActiveSection("about"));
            preventIntersectionObserver.current = true;
            scrollToTargetAdjusted(aboutRef);
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Works"
          selected={activeSection === "works"}
          onClick={() => {
            dispatch(setActiveSection("works"));
            preventIntersectionObserver.current = true;
            scrollToTargetAdjusted(worksRef);
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Experience"
          selected={activeSection === "experience"}
          onClick={() => {
            dispatch(setActiveSection("experience"));
            preventIntersectionObserver.current = true;
            scrollToTargetAdjusted(experienceRef);
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
        <NavButton
          text="Contact"
          selected={activeSection === "contact"}
          onClick={() => {
            dispatch(setActiveSection("contact"));
            preventIntersectionObserver.current = true;
            scrollToTargetAdjusted(contactRef);
            /**
             * This delay is needed to keep intersection observers disables while scrolling
             * animation plays.
             */
            setTimeout(() => {
              preventIntersectionObserver.current = false;
            }, 300);
          }}
        />
      </NavigatorButtons>
      {Number.isInteger(activeProject) && (
        <div
          className="fixed left-0 top-0 w-screen h-full z-40"
          style={{ backgroundColor: "rgba(217, 217, 217, 0.79)" }}
          onClick={() => dispatch(setActiveProject(null))}
        >
          <Modal />
        </div>
      )}
    </div>
  );
}

export default TopNav;
